import axios from "axios";
import {CARGO, TEMPLATE, EXCHANGE, CARGO_V2} from "../endpointsConst";

const FreightsService = {};

FreightsService.getTransport = () => axios.get(CARGO);
FreightsService.addCargo = (data) => axios.post(CARGO + EXCHANGE, data);
FreightsService.getCargoExchange = (params) => axios.get(CARGO_V2 + EXCHANGE, { params });
FreightsService.getMyCargo = (params) => axios.get(CARGO, { params });
FreightsService.getById = (id, params) =>
    axios.get(CARGO_V2 + EXCHANGE + `/${id}`, { params });
FreightsService.addToMyCargo = (id) => axios.post(CARGO, { cargo_id: id });
FreightsService.deleteFromMyCargo = (id) =>
    axios.patch(CARGO + EXCHANGE + `/${id}/soft-delete`);
FreightsService.searchCargo = (params, data) => axios.post(CARGO_V2 + EXCHANGE + "/search", data, { params });
FreightsService.toggleActivation = (id) => axios.patch(CARGO + EXCHANGE + `/${id}/active`);
FreightsService.exchangeUp = (id) => axios.post(CARGO + EXCHANGE + `/${id}/up-to-top`);
FreightsService.updateGpsTrackingLink = (id, gps_tracking_link) =>
    axios.patch(CARGO + EXCHANGE + `/${id}/gps-link` , { gps_tracking_link });

FreightsService.saveCargoPattern = (data) => axios.post(CARGO + TEMPLATE, data);
FreightsService.updateCargoPattern = (id, data) => axios.patch(CARGO + TEMPLATE + `/${id}`, data);
FreightsService.getCargoPatterns = (params) => axios.get(CARGO + TEMPLATE, { params });
FreightsService.getCargoPattern = (id, lang) =>
    axios.get(CARGO + TEMPLATE + `/${id}?lang=${lang}`);
FreightsService.deleteCargoPattern = (id) => axios.delete(CARGO + TEMPLATE + `/${id}`);

export { FreightsService };
